import axios from "axios";

// G3-0: empty = API on the same domain ("/api", production behind Nginx)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

// Public tracking — no credentials, no auth cookie needed.
export async function apiGetPublicTracking(token) {
  const res = await axios.get(`${API}/public/tracking/${encodeURIComponent(token)}`);
  return res.data;
}

// Public TV production feed — no login; owner 2026-10-16: locked with the TV access code
// (device token in the HttpOnly cookie of the TV, the same one as the layar produksi).
export async function apiGetTvFeed(pos) {
  const res = await axios.get(`${API}/public/tv`, { params: pos ? { pos } : {}, withCredentials: true });
  return res.data;
}

// Owner 2026-10-16 (requirement 61): layar produksi, locked with the Owner's access code.
// The device token travels in an HttpOnly cookie (withCredentials), never in JS.
const tvw = { withCredentials: true };
export async function apiTvwMasuk(kode, nama) {
  return (await axios.post(`${API}/public/tv/masuk`, { kode, ...(nama ? { nama } : {}) }, tvw)).data;  // v2.15: device name
}
export async function apiTvwLayar() {
  return (await axios.get(`${API}/public/layar-produksi`, tvw)).data;
}
export async function apiTvwKejadian(sejak) {
  return (await axios.get(`${API}/public/layar-produksi/kejadian`, { ...tvw, params: sejak == null ? {} : { sejak } })).data;
}
export async function apiTvwKeluar() {
  return (await axios.post(`${API}/public/tv/keluar`, {}, tvw)).data;
}

// F1.5-H: digital nota and the customer's order/debt page (random token, no login).
export async function apiGetNotaPublik(token) {
  return (await axios.get(`${API}/public/nota/${encodeURIComponent(token)}`)).data;
}
// Owner 2026-10-16: the customer's rating after the hand-over (once per order).
export async function apiKirimUlasan(token, payload) {
  return (await axios.post(`${API}/public/nota/${encodeURIComponent(token)}/ulasan`, payload)).data;
}
export async function apiGetInvoicePublik(token) {
  return (await axios.get(`${API}/public/nota/${encodeURIComponent(token)}/invoice`)).data;
}
export async function apiGetCustomerPublik(token) {
  return (await axios.get(`${API}/public/customer/${encodeURIComponent(token)}`)).data;
}

// F1.5-I: the customer's ACC page.
export const accMockupUrl = (token, versi) => `${API}/public/acc/${encodeURIComponent(token)}/mockup${versi ? `?versi=${versi}` : ""}`;  // A5: labelled picture
export async function apiGetAcc(token) {
  return (await axios.get(`${API}/public/acc/${encodeURIComponent(token)}`)).data;
}
// v2.19: what the open ACC page checks every ~30 s (only what the page shows; rate-limited)
export async function apiStatusAcc(token) {
  return (await axios.get(`${API}/public/acc/${encodeURIComponent(token)}/status`)).data;
}
export async function apiJawabAcc(token, payload) {
  return (await axios.post(`${API}/public/acc/${encodeURIComponent(token)}`, payload)).data;
}
